import React from "react";
import LicensingDocs from "../sections/Licensing/LicensingDocs";

const Licensing = () => {
  return (
    <>
      <LicensingDocs />
    </>
  );
};

export default Licensing;

